export default __webpack_public_path__ + "static/media/asset_calc.9cfa358a.png";